/** Join class names, skipping falsy values. */
export function cx(...parts: (string | false | null | undefined)[]): string {
  let out = "";
  for (const p of parts) {
    if (p) out += out ? ` ${p}` : p;
  }
  return out;
}
